import React from "react";
import { createStyles } from "@mantine/core";
import { cn, tokens } from "@blurb/codex-react";

const useStyles = createStyles(() => ({
  card: {
    backgroundColor: tokens.color.primitive.base.white,
    borderRadius: tokens.radius.sm,
    boxShadow: "0 4px 12px 1px rgba(0, 0, 0, 0.10)",
  },
}));

interface RpiCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const RpiCard: React.FC<RpiCardProps> = ({ children, className, ...props }) => {
  const { classes } = useStyles();

  return (
    <div className={cn(classes.card, className)} {...props}>
      {children}
    </div>
  );
};
